module.exports = __webpack_public_path__ + "img/icon_fuheguifan.e1adfc21.png";